import { useEffect } from "react";
import { goal, stage } from "@flights/et-universal";
import { useSelector } from "react-redux";
import useProfiler from "../../../hooks/useProfiler.js";
import useOfferCartOrderData from "../../../hooks/useOfferCartOrderData.js";
import web_flights_fd_genius_saving_badge_percentage from "../../../utils/experiments/genius/web_flights_fd_genius_saving_badge_percentage.js";
import { getFlightDetailsFetchStatus } from "../../../store/flightDetails/selectors.js";
import flights_funnel_baggage_in_pax_mobile_2 from "../../../utils/experiments/funnel/flights_funnel_baggage_in_pax_mobile_2.js";
export function useFlightDetailsInnerEffectsMobile(props) {
    const { flight, flightToken, isError, trackV2 } = props;
    const offerCartOrderData = useOfferCartOrderData();
    const { isLoggedIn, isMeta, isDirect } = useProfiler();
    const fetchStatus = useSelector(getFlightDetailsFetchStatus);
    useEffect(() => {
        stage("m_xm_flights_details", 1);
        if (isLoggedIn()) {
            stage("m_xm_flights_details", 2);
        }
        else {
            stage("m_xm_flights_details", 3);
        }
        if (isDirect()) {
            stage("m_xm_flights_details", 4);
        }
        else if (isMeta()) {
            stage("m_xm_flights_details", 5);
        }
    }, [isLoggedIn, isDirect, isMeta]);
    useEffect(() => {
        const { parentOfferToken } = offerCartOrderData.get(flightToken);
        offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: parentOfferToken || flightToken });
    }, [flightToken, offerCartOrderData]);
    useEffect(() => {
        if (isLoggedIn() && flight) {
            web_flights_fd_genius_saving_badge_percentage.stages.land_on_fd();
        }
    }, [flight, isLoggedIn]);
    useEffect(() => {
        if (fetchStatus === "failed") {
            trackV2("show_error_page");
        }
    }, [fetchStatus, flight, trackV2]);
    useEffect(() => {
        if (isError)
            goal("flights_flight_details_loading_error");
    }, [isError]);
    useEffect(() => {
        if (flight) {
            flights_funnel_baggage_in_pax_mobile_2.stages.flight_details();
        }
    }, [flight]);
    return {};
}
